export default __webpack_public_path__ + "static/media/zukunf_lauft_grid_xl.a67064f9.jpg";